import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { FiverrLightDotLightLogo } from '@fiverr-private/visuals';
import { MIXPANEL_EVENTS, sendMixpanelEvent } from '../../shared/tracking';
import { HEADER_CTA_TEXT, HEADER_CTA_TEXT_MOBILE } from './constants';
import { ctaButton, desktopOnly, header, mobileOnly } from './styles.ve.css';

interface HeaderSectionProps {
  onPrimaryCtaClick: () => void;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({ onPrimaryCtaClick }) => {
  const handleCtaClick = () => {
    sendMixpanelEvent({ eventName: MIXPANEL_EVENTS.CLICKED_HEADER_CTA });
    onPrimaryCtaClick();
  };

  return (
    <Container className={header}>
      <Stack direction="row" alignItems="center" justifyContent="spaceBetween">
        <FiverrLightDotLightLogo size="sm" />
        <button type="button" className={ctaButton} onClick={handleCtaClick}>
          <span className={mobileOnly}>{HEADER_CTA_TEXT_MOBILE}</span>
          <span className={desktopOnly}>{HEADER_CTA_TEXT}</span>
        </button>
      </Stack>
    </Container>
  );
};

export default HeaderSection;
